import { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { PersonalMessages } from '../../_lib/components/PersonalMessages';

export const PersonalMessagesBlock = asFetchableBlock(PersonalMessages, BlockType.personalmessages);
export type PersonalMessagesBlock = ComponentProps<typeof PersonalMessagesBlock>;
